<template>
  <div class="pageContent">
    <el-row class="blod">设备信息</el-row>
    <div style="min-width: 1240px">
      <el-row style="overflow-x:hidden" :span="24" class="colContent">

        <template v-for="(item, index) in dataList">
          <el-col :span="8" class="outCol" :key="index">
            <el-col :span="12">{{ item.name }}
              <el-tooltip v-if="item.name === '设备昵称' || item.name === '实时延迟'"
                :content="item.name === '设备昵称' ? tips.nickNameTips : tips.delayTips" placement="top" effect="light">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </el-col>

            <!-- {{ item.firmwareList }} -->

            <!-- [
              { "id": null, "productKey": null, "deviceName": null, "moduleName": "app", "moduleVersion": "3.3.0.4", "remark": null, "isDelete": null, "createTime": null, "updateTime": "2024-04-17 15:46:01" }, 
              { "id": null, "productKey": null, "deviceName": null, "moduleName": "diff", "moduleVersion": "1.6.9", "remark": null, "isDelete": null, "createTime": null, "updateTime": "2024-04-17 15:46:01" }, 
              { "id": null, "productKey": null, "deviceName": null, "moduleName": "default", "moduleVersion": "1.6.9", "remark": null, "isDelete": null, "createTime": null, "updateTime": "2024-04-17 15:46:01" }
            ] -->

            <!-- <el-col :span="12" v-if="item.firmwareList && item.firmwareList.length > 0">
              <el-tooltip :content="item.firmwareList[0].moduleName + '-' + item.firmwareList[0].moduleVersion"
                placement="top" effect="light">
                {{ item.firmwareList[0].moduleName + '-' + item.firmwareList[0].moduleVersion }}
              </el-tooltip> 
              <span class="btn" v-if="item.firmwareList.length > 0" @click="moreView.moreVisible = true">更多</span>
            </el-col> -->

            <!-- <el-col span="2">
              <el-tooltip content="123123123"
                placement="top" effect="light">
                3234
              </el-tooltip> 
              <span class="btn" v-if="item.firmwareList.length > 0" @click="moreView.moreVisible = true">更多</span>
            </el-col> -->

            <el-col :span="12">
              {{ item.value }}
              <span class="btn" @click="edit(item.value)" v-if="item.name === '设备昵称'">编辑</span>
              <span class="btn" @click="copy(`${item.value}`)"
                v-if="item.name === 'productKey' || item.name === '设备名称'">复制</span>
              <span class="btn" v-if="item.name === '实时延迟'">测试</span>
              <span class="btn" v-if="item.name === 'X.509' && data.certDownloadAddress"
                @click="download(`${data.certDownloadAddress}`)">下载</span>

              <div v-if="item.name === '固件版本'">
                <el-tooltip :content="item.firmwareList[0].moduleName + '-' + item.firmwareList[0].moduleVersion"
                  placement="top" effect="light">
                  {{ item.firmwareList[0].moduleName + '-' + item.firmwareList[0].moduleVersion }}
                </el-tooltip> 
                <span class="btn" v-if="item.firmwareList.length > 0" @click="moreView.moreVisible = true">更多</span>
              </div>
              
            </el-col>

          </el-col>

          

        </template>
        <!-- <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col>
        <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col>
        <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col>
        <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col>
        <el-col :span="4">产品名称</el-col><el-col :span="4">8888</el-col> -->
      </el-row>
    </div>
    <div v-if="data.nodeType === 2">
      <el-row class="blod">是否允许设备端绑定子设备</el-row>
      <el-switch @change="handleChange" :active-value="true" :inactive-value="false" v-model="switchVal"
        :inactive-text="switchVal ? '禁用' : '启用'" active-color="#13ce66" inactive-color="#ff4949">
      </el-switch>
    </div>
    <nickNameView v-if="editParams.editVisible" :placeholderName="nickName" :editParams="editParams"
      v-on:close-view="changeNickName" :deviceName="data.deviceName" :productKey="data.productKey"></nickNameView>
    <moreVersionDrawer v-if="data.firmwareList && data.firmwareList.length > 0" :firmwareList="data.firmwareList"
      :moreView="moreView" v-on:close-view="moreView.moreVisible = false">
    </moreVersionDrawer>
  </div>
</template>
<script>
import nickNameView from '@/components/deviceManage/nickNameView'
import moreVersionDrawer from '@/components/deviceManage/moreVersionDrawer'
import { copy, loadFileByUrl } from '@/utils'
import { deviceEdit } from '@/api/deviceManagement'
export default {
  components: {
    nickNameView,
    moreVersionDrawer
  },
  props: ['data'],
  data: function () {
    return {
      dataList: [],
      editParams: {
        editVisible: false
      },
      tips: {
        nickNameTips: '支持中文、英文字母、数字和下划线，1~20 个字符',
        delayTips: '根据 MQTT 协议 QoS1 消息的 ACK 回执时间估算出的设备网络延迟实时值，暂不支持测试其他协议连接的设备'
      },
      moreView: {
        moreVisible: false
      },
      switchVal: true,
      nickName: ''
    }
  },
  methods: {
    initData() {
      /** nodeType
          0：直连设备
          1：网关子设备
          2：网关设备 */
      const nodeType =
        this.data.nodeType.toString() === '0'
          ? '直连设备'
          : this.data.nodeType.toString() === '1'
            ? '网关子设备'
            : this.data.nodeType.toString() === '2'
              ? '网关设备'
              : ''
      //  authType
      // 0:     设备秘钥
      // 1：key为： X.509 （xCertificateName）如果是1，authType 展示X.509: 取它的值xcertificateName
      const authType =
        this.data.authType.toString() === '0'
          ? { name: '认证方式', value: '设备秘钥' }
          : { name: 'X.509', value: this.data.xcertificateName }

      this.dataList = [
        { name: '产品名称', value: this.data.productName },
        { name: 'productKey', value: this.data.productKey },
        { name: '节点类型', value: nodeType.toString() },
        { name: '设备名称', value: this.data.deviceName },
        { name: authType.name, value: authType.value },
        { name: '设备昵称', value: this.data.nickName },
        { name: 'IP地址', value: this.data.ipAddress },
        { name: '固件版本', firmwareList: this.data.firmwareList && this.data.firmwareList.length > 0 ? this.data.firmwareList : null },
        // { name: '固件版本', value: 1 },
        { name: '添加时间', value: this.data.createTime },
        { name: '激活时间', value: this.data.activationTime },
        { name: '最后上线时间', value: this.data.lastOnlineTime },
        { name: '当前状态', value: this.getStatus(this.data.deviceStatus) }
        // { name: '实时延迟', value: '' }
      ]
    },
    getStatus(deviceStatus) {
      const stateParams = {
        0: 'ONLINE',
        1: 'OFFLINE',
        2: 'UNACTIVE',
        3: 'DISABLE'
      }
      return stateParams[deviceStatus]
      // return deviceStatus === 'DISABLE'
      //   ? { class: 'disabled', text: '已禁用' }
      //   : deviceStatus === 'UNACTIVE'
      //     ? { class: 'inactive', text: '未激活' }
      //     : deviceStatus === 'ONLINE'
      //       ? { class: 'online', text: '在线' }
      //       : { class: 'offline', text: '离线' }
    },
    copy(val) {
      copy(val, () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      })
    },
    changeNickName(nickName) {
      this.editParams.editVisible = false
      nickName ? this.dataList[5].value = nickName : ''
      console.log('changeNickName:', nickName)
    },
    download(path) {
      console.log('path:', path)
      if (path) {
        // window.open(path)
        loadFileByUrl(path)
      } else {
        this.$message.error('下载出错')
      }
    },
    // swithch 开关
    handleChange(val) {
      console.log(val)
      const params = {
        deviceName: this.data.deviceName,
        productKey: this.data.productKey,
        isToPoRelation: +this.switchVal
      }
      console.log(params)
      deviceEdit(params).then(res => {
        console.log(res)
        if (res.data.code) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        }
      })
    },
    edit(name) {
      this.editParams.editVisible = true
      this.nickName = name
      this.editParams.editVisible = true
      console.log('-----------', this.nickName)
    }
  },
  created() {
    // console.log('展示详情数据接收：', this.data)
    this.initData()
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log('this.data改变', this.data)
        console.log(this.data.isToPoRelation)
        this.switchVal = this.data.isToPoRelation
        this.initData()
      }
    }
  }
}
</script>
<style lang="less" scope>
.pageContent {
  .blod {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #373d41;
    margin-bottom: 20px;
  }

  .colContent {
    margin-bottom: 20px;
    color: #73777a;
    border-top: 1px solid #ecedee;
    border-left: 1px solid #ecedee;
    min-width: 1400px;

    .outCol {
      .el-col {
        border-right: 1px solid #ecedee;
        border-bottom: 1px solid #ecedee;
        line-height: 50px;
        height: 50px;
        padding-left: 10px;

        &:nth-child(odd) {
          background-color: #fbfbfc;
        }
      }
    }

    .btn {
      color: rgb(0, 112, 204);
      margin-left: 10px;
      cursor: pointer;
      font-size: 10px;
    }
  }

  .el-icon-question {
    margin-left: 5px;
    color: rgb(204, 204, 204);
  }

  /* .el-switch__label.is-active{
    color: #13ce66;
  } */
}
</style>
